import { useIntl } from 'react-intl';

import {
	ProductPriceCardProps,
	FreePriceCard,
	StandardPriceCard,
	PremiumPriceCard,
	EnterprisePriceCard,
} from './pricing-calculator-plan-card.tsx';

export const ServiceCollectionFreePriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();
	return (
		<FreePriceCard
			{...props}
			tierLabelType="agent"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'ServiceCollectionPriceCard.perAgentPerMonth',
				defaultMessage: 'per agent / month',
			})}
		/>
	);
};

export const ServiceCollectionStandardPriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();
	return (
		<StandardPriceCard
			{...props}
			tierLabelType="agent"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'ServiceCollectionPriceCard.perAgentPerMonth',
				defaultMessage: 'per agent / month',
			})}
		/>
	);
};

export const ServiceCollectionPremiumPriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();
	return (
		<PremiumPriceCard
			{...props}
			tierLabelType="agent"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'ServiceCollectionPriceCard.perAgentPerMonth',
				defaultMessage: 'per agent / month',
			})}
		/>
	);
};

export const ServiceCollectionEnterprisePriceCard = (props: ProductPriceCardProps) => {
	const intl = useIntl();
	return (
		<EnterprisePriceCard
			{...props}
			tierLabelType="agent"
			monthlyPerUserLabel={intl.formatMessage({
				id: 'ServiceCollectionPriceCard.perAgentPerMonth',
				defaultMessage: 'per agent / month',
			})}
		/>
	);
};
